(() => {
  const selector = '.quick-add__submit,.product-form__submit,.cart__checkout-button,.shopify-payment-button__button--unbranded';
  const properties = {
    background: 'rgb(197, 236, 145)',
    'background-color': 'rgb(197, 236, 145)',
    border: '0px',
    color: 'rgb(0, 0, 0)',
    'box-shadow': 'none',
    'text-transform': 'uppercase',
    '--color-button': '197, 236, 145',
    '--color-button-text': '0, 0, 0'
  };
  function apply(root) {
    const buttons = [];
    if (root.matches?.(selector)) buttons.push(root);
    if (root.querySelectorAll) buttons.push(...root.querySelectorAll(selector));
    for (const button of buttons) {
      for (const [key, value] of Object.entries(properties)) {
        if (button.style.getPropertyValue(key) !== value || button.style.getPropertyPriority(key) !== 'important') {
          button.style.setProperty(key, value, 'important');
        }
      }
    }
  }
  function start() {
    const observer = new MutationObserver((records) => {
      observer.disconnect();
      for (const record of records) {
        if (record.type === 'attributes') apply(record.target);
        else for (const node of record.addedNodes) if (node.nodeType === 1) apply(node);
      }
      watch();
    });
    function watch() {
      observer.observe(document.body, {childList:true,subtree:true,attributes:true,attributeFilter:['style','class','disabled']});
    }
    apply(document);
    watch();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();